import styled, { css } from 'styled-components';

export const StyledSwitchCheckbox = styled.input`
  position: relative;
  appearance: none;
  outline: none;

  background-color: #ffffff;
  border: 1px solid #d6d6d6;
  border-radius: 50px;
  transition-duration: 200ms;
  cursor: pointer;

  ${({ size = 'big' }) => {
    if (size === 'big') {
      return css`
        width: 41px;
        max-width: 41px;
        min-width: 41px;
        height: 20px;
        box-shadow: inset -20px 0 0 0 #d6d6d6;

        :checked {
          border-color: #ff7828;
          box-shadow: inset 20px 0 0 0 #ff7828;
        }

        :checked:after {
          left: 20px;
          box-shadow: -2px 4px 3px rgba(0, 0, 0, 0.05);
        }

        :after {
          content: '';
          position: absolute;
          top: 1px;
          left: 1px;
          width: 17px;
          height: 17px;
          background-color: transparent;
          border-radius: 50%;
          box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
        }
      `;
    }
    if (size === 'small') {
      return css`
        width: 27px;
        max-width: 27px;
        min-width: 27px;
        height: 14px;
        box-shadow: inset -14px 0 0 0 #d6d6d6;

        :checked {
          border-color: #ff7828;
          box-shadow: inset 14px 0 0 0 #ff7828;
        }

        :checked:after {
          left: 14px;
          box-shadow: -2px 4px 3px rgba(0, 0, 0, 0.05);
        }

        :after {
          content: '';
          position: absolute;
          top: 1px;
          left: 1px;
          width: 10px;
          height: 10px;
          background-color: transparent;
          border-radius: 50%;
          box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.2);
        }
      `;
    }
    return css`
      width: 41px;
      max-width: 41px;
      min-width: 41px;
      height: 20px;
    `;
  }}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;
